var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartIconOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41963 4.581C5.46285 3.53778 6.94292 2.98793 8.38954 3.20514C9.69305 3.40087 10.9306 4.21303 11.7783 5.76785C12.626 4.21303 13.8636 3.40087 15.1671 3.20514C16.6137 2.98793 18.0938 3.53778 19.137 4.581C20.2361 5.6801 20.5671 7.20592 20.4701 8.63901C20.3733 10.0697 19.8476 11.461 19.1628 12.3421C17.8708 14.0047 17.4103 14.4953 16.2412 15.6351C15.6542 16.2075 14.893 16.8758 14.2818 17.3985C13.9755 17.6604 13.7056 17.8868 13.5122 18.0478C13.4155 18.1283 13.3379 18.1925 13.2844 18.2366L13.2229 18.2873L13.213 18.2954C12.8152 18.6871 12.2962 18.883 11.7783 18.883C11.2604 18.883 10.7414 18.6871 10.3436 18.2954L10.3337 18.2873L10.2722 18.2366C10.2187 18.1925 10.1411 18.1283 10.0444 18.0478C9.85105 17.8868 9.58115 17.6604 9.27487 17.3985C8.66362 16.8758 7.90239 16.2075 7.31539 15.6351C6.1463 14.4953 5.68584 14.0047 4.39378 12.3421C3.709 11.461 3.18337 10.0697 3.08652 8.63901C2.98951 7.20592 3.32054 5.6801 4.41963 4.581Z",
    stroke: "#B5B5B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIconOff);
export default __webpack_public_path__ + "static/media/heartIconOff.d293b6453069eb178ce362e8c38e5762.svg";
export { ForwardRef as ReactComponent };